import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function bpBetBuilderRouteI18n(): string {
  return (appRoutesI18nCache['bp-bet-builder'] ??= $localize`:url-segment@@bp-bet-builder-url-segment:bet-builder`);
}
